import { Component, Prop, h, Host, Element } from "@stencil/core";
import { LanguageSelectorProps } from "frontend-kit/molecules/f-language-selector/f-language-selector-model";

@Component({
  tag: "f-profile-flyout",
  styleUrl: "f-profile-flyout.scss",
  shadow: false,
})
export class FProfileFlyout {
  @Element() el: HTMLFProfileFlyoutElement;

  @Prop() buttonHiddenLabel = "Profile";
  @Prop() buttonTitle = this.buttonHiddenLabel;
  @Prop() closeButtonHiddenLabel;
  @Prop() flyoutTitle: string;
  @Prop() username?: string;
  @Prop() userEmail?: string;
  @Prop() initials?: string;
  @Prop() languageLinkUrl: LanguageSelectorProps["linkUrl"] =
    "https://www.bosch.com/websites-worldwide/";

  // TT CUSTOM START
  @Prop() label: string;
  // TT CUSTOM END

  render() {
    return (
      <Host data-test="mini-profile">
        <f-flyout-with-button
          flyoutTitle={this.flyoutTitle}
          flyoutId="f-profile-flyout"
          buttonIconName="my-brand-frame"
          buttonTitle={this.buttonTitle}
          closeButtonHiddenLabel={this.closeButtonHiddenLabel}
          flyoutDataTest="profile-flyout"
          iconPosition="right"
        >
          {this.username ? (
            <span class="f-profile-flyout__username">{this.username}</span>
          ) : (
            ""
          )}
          <f-visually-hidden>{this.buttonHiddenLabel}</f-visually-hidden>
          <f-flyout-feature-bar variant="single" slot="flyout-feature-bar">
            {Boolean(this.username) ? (
              <f-profile-flyout-user-bar
                slot="feature-bar-content"
                email={this.userEmail}
                username={this.username}
                initials={this.initials}
              ></f-profile-flyout-user-bar>
            ) : (
              ""
            )}
          </f-flyout-feature-bar>
          <div slot="flyout-content">
            <slot name="profile-flyout-content" />
          </div>
          <f-flyout-footer slot="flyout-footer">
            <f-language-selector
              slot="flyout-footer-content"
              isLightTheme={true} //TTRQ-53602 custom
              linkUrl={this.languageLinkUrl}
              label={this.label} //TT CUSTOM
            ></f-language-selector>
          </f-flyout-footer>
        </f-flyout-with-button>
      </Host>
    );
  }
}
